import axios from 'axios'

const FOLLOWEE_IDS_FETCHED = 'FOLLOWEE_IDS_FETCHED'

const API_URL = process.env.API_URL

const state = {
  ids: []
}

const actions = {
  async fetchFollowees ({ commit }) {
    const {
      data: {
        data: { users: ids }
      }
    } = await axios.get(API_URL + '/follow')

    commit(FOLLOWEE_IDS_FETCHED, ids)
    return ids
  },
  async updateFollowees ({ commit }, ids) {
    await axios.put(API_URL + '/follow', {
      users: ids
    })
    commit(FOLLOWEE_IDS_FETCHED, ids)
    return ids
  }
}

const mutations = {
  [FOLLOWEE_IDS_FETCHED] (state, ids) {
    state.ids = ids
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/autofollowees.js